// extracted by css-extract-rspack-plugin
export default {"table":"table-sKi72D","list-item":"list-item-TvcCVL","listItem":"list-item-TvcCVL"};